import { render, staticRenderFns } from "./NewVaultModalContent.vue?vue&type=template&id=f52ce820&scoped=true&"
import script from "./NewVaultModalContent.vue?vue&type=script&lang=js&"
export * from "./NewVaultModalContent.vue?vue&type=script&lang=js&"
import style0 from "./NewVaultModalContent.vue?vue&type=style&index=0&id=f52ce820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52ce820",
  null
  
)

export default component.exports